export default __webpack_public_path__ + "static/media/logo.927f1d60.svg";